import { IConfig } from '../../types';
import { AppActionTypes } from '../actions';

enum Types {
  GET_CONFIG_LOADED = 'GET_CONFIG_LOADED',
}

const configReducer = (state: IConfig, action: AppActionTypes): IConfig => {
  switch (action.type) {
    case Types.GET_CONFIG_LOADED:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export default configReducer;
